export function downloadHtmlFileContent(htmlFileUrl, updateProgress) {
  const downloadProgress = (e) => {
    if (e.lengthComputable) {
      const percentComplete = (e.loaded / e.total) * 100;
      updateProgress && updateProgress(percentComplete);
    }
  };

  return new Promise(
    // resolve on success, reject on error or non-200
    (resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', htmlFileUrl);
      // xhr.setRequestHeader('x-amz-acl', 'public-read');
      // xhr.setRequestHeader('Content-Type', contentType || 'audio/wav');
      // xhr.setRequestHeader('Content-Disposition', 'inline');

      xhr.onreadystatechange = (e) => {
        if (xhr.readyState !== 4) {
          // not comoleted
          return;
        }
        if (xhr.status === 200) {
          // console.log('xhr success', xhr.responseText);
          resolve({ status: 200, htmlContent: xhr.responseText });
        } else {
          // console.log('xhr error');
          reject();
        }
      };

      xhr.onload = function () {
        if (xhr.status === 200) {
          // console.log('xhr success onload');
        } else {
          // console.log('result err = ', xhr);
        }
      };

      xhr.onprogress = downloadProgress;

      xhr.onerror = function (err) {
        // console.log('err xhr', err);
        reject(err);
      };

      xhr.send();
    }
  );
}
